import { LayoutStandardPage } from "../layout/LayoutStandardPage"
import { PartialHomePage } from "../layout/Partial/PartialHomePage";

export const HomePage = () => {

    return(
        <LayoutStandardPage component={PartialHomePage.toString()} />
    )
}